<div class="container-fluid py-5">
  <div class="row">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-body p-5">
          <h3 class="pt-0 pb-4">GSA 3080 Survey Search Results Based on Employee Last Name: {{ this.emplLastName }}</h3>
          <h4>To View, Reset, Modify or Delete a GSA 3080 Survey, select the appropriate "Survey Number." </h4>
          <!-- <div class="row" *ngIf="showExport">
            <div style="padding-bottom: 4px; float: right !important;">
              <label style="margin-left: 20px;"> <button type="button" (click)="onBtnExport()">Export to CSV</button> </label>
            </div>
          </div> -->
          <div class="row col-md-12">
           <ag-grid-angular class="ag-theme-alpine"
               style="width: 100%; height: 500px;"
              [rowData]="cleanData"
              [pagination]="true"
              [masterDetail]="true"
              [columnDefs]="listSurveybyLastName"
              [defaultColDef]="defaultColDef"
              [paginationPageSize]="paginationPageSize">
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
